import React from 'react';

import { PoolNodePresenceIcon } from '~src/settings/dataconnect-settings/sections/dataConnectPoolNodes/PoolNodePresenceIcon';

import { Node } from '../types/Node';
import { gePoolNodeStatus } from './PoolNodeStates';

export function DataConnectPoolNodesPresenceIcon(node: Node, poolTestId: string) {
  return (
    <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'pool-node-status-cell' + poolTestId}>
      {renderPoolNodePresenceIcon(node)}
    </span>
  );
}

function renderPoolNodePresenceIcon(node: Node) {
  const poolNodeStatus = gePoolNodeStatus();

  if (node.nodeStatus !== null) {
    return (<>
      <PoolNodePresenceIcon status={node.nodeStatus} poolNodeStatus={ poolNodeStatus} />
      {poolNodeStatus[node.nodeStatus].stateLabel}
    </>);
  }

  return null;
}
